import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { Link } from '../../components/global/Link';
import { useAuth } from '../../contexts/AuthContext';
import AssetRegisterLogo from '../../assets/images/logo.svg';

interface ForgotPasswordError {
  email?: string;
}

export const ForgotPassword = () => {
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState('');
  const { forgotPassword } = useAuth();
  const [error, setError] = useState<ForgotPasswordError>({});

  const handleSendLink = async () => {
    const { errors } = await forgotPassword(email);
    if (errors) {
      setError(errors);
    } else {
      setSent(true);
    }
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100vh"
      paddingBottom={6}>
      <Stack
        sx={{ maxWidth: '500px', width: '100%' }}
        spacing={4}
        alignItems="center">
        <Stack width="100%" justifyContent="center" alignItems="center">
          <img src={AssetRegisterLogo} height={120} />
        </Stack>
        <Stack width="80%" justifyContent="center" alignItems="center" pt={8}>
          <Typography
            variant="h4"
            gutterBottom
            fontFamily="korolev-condensed"
            fontWeight="600"
            letterSpacing="1px">
            Forgot Password
          </Typography>
          {sent ? (
            <Typography variant="body2" gutterBottom textAlign="center">
              Please check your email, we sent you a link to reset your
              password.
            </Typography>
          ) : (
            <Typography variant="body2" gutterBottom textAlign="center">
              Please enter your email address below and we will send you a link
              to reset your password.
            </Typography>
          )}
        </Stack>
        <Stack component="form" width="100%" spacing={4}>
          <Stack width="100%">
            {!sent && (
              <>
                <Typography variant="body2">Email</Typography>
                <TextField
                  variant="outlined"
                  value={email}
                  error={error.email ? true : false}
                  helperText={error?.email?.[0] ?? ''}
                  onChange={e => setEmail(e.target.value)}
                />
              </>
            )}
          </Stack>
        </Stack>
        <Stack spacing={1} justifyContent="center" alignItems="center">
          {sent ? null : (
            <Stack alignItems="center" justifyContent="center">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ fontWeight: '900', textTransform: 'unset' }}
                onClick={handleSendLink}>
                Send Link
              </Button>
            </Stack>
          )}
          <Link to="/signin">
            <Typography variant="body2" color="primary" fontWeight="600">
              Sign In
            </Typography>
          </Link>
        </Stack>
      </Stack>
    </Stack>
  );
};
